import { Wizard as WizardComp } from './Wizard';
import { WizardButton } from './Wizard.Button';
import { WizardStep } from './Wizard.Step';
export * from './selectors';
export * from './state';

function buildWizardExport() {
  return Object.assign(WizardComp, {
    Button: WizardButton,
    Step: WizardStep
  });
}

export var Wizard = buildWizardExport();